<div class="cp-modal cp-feedback-modal">
	<div class="cp-modal-header" mat-dialog-title align="start">
		<h2 class="cp-modal-title">Feedback Submission</h2>
		<button mat-icon-button
			[disabled]="isSubmitting"
			(click)="onClose()"
			aria-label="Close feedback modal"
			data-testid="feedback-close-button"
			disableRipple>
			<mat-icon fontSet="material-symbols-outlined">close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="cp-modal-content">
		<form [formGroup]="form">
			<!-- Question 1 -->
			<div class="cp-feedback-question" data-testid="question-1">
				<p class="cp-feedback-question-text">1. How satisfied are you with your Portal <span class="cp-no-wrap">experience?<span class="cp-required" aria-hidden="true">*</span></span></p>
				<div class="cp-rating-error-container">
					@if (showQues1Error) {
						<p id="q1-rating-error" class="cp-rating-error-msg" role="alert" data-testid="q1-rating-error">Please make a selection</p>
					}
				</div>
				<div class="cp-rating-group" role="group" aria-label="How satisfied are you with your Portal experience?" [attr.aria-invalid]="showQues1Error || null" [attr.aria-describedby]="showQues1Error ? 'q1-rating-error' : null" (focusout)="onRatingGroupBlur($event, 'ratingQues1')">
					@for (option of ratingOptions; track option.value) {
						<button type="button"
							class="cp-rating-btn"
							[class.cp-rating-btn--selected]="ratingQues1 === option.value"
							[attr.data-rating]="option.value"
							[attr.aria-label]="option.label"
							[attr.aria-pressed]="ratingQues1 === option.value ? 'true' : 'false'"
							[tabindex]="0"
							[attr.data-testid]="'q1-rating-' + option.value"
							[matTooltip]="option.label"
							matTooltipPosition="above"
							(click)="selectRating('ratingQues1', option.value)">
							<span class="cp-emoji">{{option.emoji}}</span>
						</button>
					}
				</div>
			</div>

			<!-- Question 2 -->
			<div class="cp-feedback-question" data-testid="question-2">
				<p class="cp-feedback-question-text">2. How well were you able to accomplish what you came here to do <span class="cp-no-wrap">today?<span class="cp-required" aria-hidden="true">*</span></span></p>
				<div class="cp-rating-error-container">
					@if (showQues2Error) {
					<p id="q2-rating-error" class="cp-rating-error-msg" role="alert" data-testid="q2-rating-error">Please make a selection</p>
					}
				</div>
				<div class="cp-rating-group" role="group" aria-label="How well were you able to accomplish what you came here to do today?" [attr.aria-invalid]="showQues2Error || null" [attr.aria-describedby]="showQues2Error ? 'q2-rating-error' : null" (focusout)="onRatingGroupBlur($event, 'ratingQues2')">
					@for (option of ratingOptions; track option.value) {
					<button type="button"
						class="cp-rating-btn"
						[class.cp-rating-btn--selected]="ratingQues2 === option.value"
						[attr.data-rating]="option.value"
						[attr.aria-label]="option.label"
						[attr.aria-pressed]="ratingQues2 === option.value ? 'true' : 'false'"
						[tabindex]="0"
						[attr.data-testid]="'q2-rating-' + option.value"
						[matTooltip]="option.label"
						matTooltipPosition="above"
						(click)="selectRating('ratingQues2', option.value)">
						<span class="cp-emoji">{{option.emoji}}</span>
					</button>
					}
				</div>
			</div>

			<!-- Question 3 -->
			<div class="cp-feedback-question" data-testid="question-3">
				<p class="cp-feedback-question-text">3. Tell us about your experience and how we can improve. For support issues, please contact your homesite team. (Optional)</p>
				<mat-form-field appearance="outline" class="cp-feedback-text-field" [class.cp-feedback-text-field--error]="isOverLimit || hasLinkError">
					<textarea matInput
						formControlName="feedbackText"
						placeholder="Tell us more about your experience."
						aria-label="Tell us about your experience and how we can improve"
						data-testid="feedback-text"
						[attr.aria-invalid]="isOverLimit || hasLinkError"
						[attr.aria-describedby]="isOverLimit ? 'feedback-char-error' : hasLinkError ? 'feedback-link-error' : 'feedback-char-count'">
					</textarea>
					<mat-hint align="end" id="feedback-char-count" [class.cp-char-count--error]="isOverLimit" data-testid="char-count">
						{{charCount}}/{{maxChars}}
					</mat-hint>
					@if (isOverLimit) {
					<mat-hint align="start" id="feedback-char-error" [class.cp-char-count--error]="isOverLimit" data-testid="char-error">
						Response must be {{maxChars}} characters or fewer.
					</mat-hint>
					}
					@if (hasLinkError) {
					<mat-hint align="start" id="feedback-link-error" class="cp-char-count--error" data-testid="link-error">
						Links are not allowed in this field.
					</mat-hint>
					}
				</mat-form-field>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions class="cp-modal-actions" align="center">
		<button mat-button
			[aria-disabled]="isSubmitting"
			[disabled]="isSubmitting"
			color="accent"
			(click)="onCancel()"
			data-testid="feedback-cancel-button">
			Cancel
		</button>
		<button mat-button
			color="primary"
			[disabled]="isSubmitDisabled"
			(click)="onSubmit()"
			data-testid="feedback-submit-button">
			Submit Feedback
		</button>
	</mat-dialog-actions>
</div>

@if (isSubmitting) {
	<div class="cp-feedback-spinner-overlay">
		<cp-spinner></cp-spinner>
	</div>
}
